import { render, staticRenderFns } from "./GraficaTortaReporteria.vue?vue&type=template&id=b9f34772&"
import script from "./GraficaTortaReporteria.vue?vue&type=script&lang=js&"
export * from "./GraficaTortaReporteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports